import React, {useState, useEffect, useRef} from 'react';
import _get from 'lodash/get';
import { Helmet } from "react-helmet";
import './style.css';
import Footer from 'components/Footer/Footer';
import Button from 'components/Button/Button';
import CityImage from 'Assets/events-hero.png';
import { local_routes } from 'utils/Routes';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import home from 'Assets/home.svg';
import logoCity from 'Assets/logo-city.png';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import CityBanner from 'components/Banner/CityBanner';
import TitleSection from 'components/TitleBar/TitleSection';
import UpcomingEventsCom from 'components/UpcomingEvents/UpcomingEvents';
import EmptyUpcomingEvents from 'components/CityUpcomingEvents/EmptyUpcomingEvents';
import SpotLightPk from 'components/spotlightedPK/spotlightedPK';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import { current_unix_stamp, unixDateConversion, dateConvert, DaysDiff, HoursDiff } from 'utils/Helper';
import { searchUrl, events_list_api, apiUrl, HeaderConfig, search_Presentation_API, user_entity_uuid, presentation_Creation_API, user_Status, myHeaders_Autorized, myHeaders_Auth_With_Cache_Control, myHeaders_With_Cache_Control } from "Api/Api";
//import Trending from 'components/TrendingNow/Trending';
import PresentationCard from "components/PresentationCard/PresentationCard";
import Organizer from 'components/Organizers/Organizers';
import emptyEventImg from 'Assets/upcoming-events.png';

const City = (props) => {
  //console.log('CITY PROPS:', props)
  const [followed, set_followed] = useState(false)
  const [loading, set_loading] = useState(true);
  const [events_loading, set_events_loading] = useState(true);
  const [like_loader, set_like_loader] = useState(false)
  const [like_count, set_like_count] = useState(0)
  const [label_like, set_label_like] = useState('like')
  const [page_title, set_page_title] = useState('PechaKucha 20x20')
  const [city_detail_info, set_city_detail_info] = useState({})
  const [location_owner, set_location_owner] = useState(false)
  const [organizer_arr, set_organizer_arr] = useState({})
  const [no_organizer, set_no_organizer] = useState(false)
  const [spotlight_pk, set_spotlight_pk] = useState({})
  const [spotlight_pk_presenter, set_spotlight_pk_presenter] = useState({})
  const [past_event_arr, set_past_event_arr] = useState([])
  const [future_event_arr, set_future_event_arr] = useState([])
  const [all_event_arr, set_all_event_arr] = useState([])
  const [got_all_past, set_got_all_past] = useState(false)
  const [got_all_future, set_got_all_future] = useState(false)
  const [got_all_all, set_got_all_all] = useState(false)
  const [load_more_loader, set_load_more_loader] = useState(false)
  const [speakers_list, set_speakers_list] = useState([])
  const [presenters_total_limit, set_presenters_total_limit] = useState(0)
  const [presenters_current_limit, set_presenters_current_limit] = useState(6)
  const [hide_more_speaker_btn, set_hide_more_speaker_btn] = useState(false)
  const [is_switch_on, set_is_switch_on] = useState(false)
  
  const [from, set_from] = useState(0)
  const [limit, set_limit] = useState(3)

  const [pk_detail_from, set_pk_detail_from] = useState(0)
  const [pk_detail_limit, set_pk_detail_limit] = useState(3)

  const [pk_recent_detail_from, set_pk_recent_detail_from] = useState(0)
  const [pk_recent_detail_limit, set_pk_recent_detail_limit] = useState(3)

  const [hide_more_pk_btn, set_hide_more_pk_btn] = useState(false)
  const [pk_detail_data, set_pk_detail_data] = useState([])
  const [pk_more_data_loader, set_pk_more_data_loader] = useState(false)
  const [pk_recent_detail_data, set_pk_recent_detail_data] = useState([])
  const [pk_recent_more_data_loader, set_pk_recent_more_data_loader] = useState(false)
  const [hide_more_pk_recent_btn, set_hide_more_pk_recent_btn] = useState(false)
  //const [current_limit, set_current_limit] = useState(3)


  useEffect(() => {
    if (props.location.search === "?show_pks_toggle=recent") {
      set_is_switch_on(true)
    } else if (props.location.search === "?show_pks_toggle=trending") {
      props.history.push(props.location.pathname);
    }
    //set_current_limit(12);
    routeChanged()
  }, [])

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    } 

    routeChanged();
  }, [props.location.pathname])

  const routeChanged = () => {
    set_from(0)
    set_limit(3)
    set_all_event_arr([])
    set_past_event_arr([])
    set_future_event_arr([])

    APICalls()
  }


  

  // Component Did Mount
  const APICalls = async () => {
    let { match: { params: { friendly_url } = {} } = {} } = props
    friendly_url = friendly_url.toLowerCase();
    let api_promises = [];
    api_promises.push(axios.get(`${apiUrl}locations/${friendly_url}`));
    api_promises.push(axios.get(`${apiUrl}locations/${friendly_url}/users`));

    if (user_Status === 1) {
      api_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience/${friendly_url}`, myHeaders_Auth_With_Cache_Control));
    }  
    const [locationApiRes,cityUsersRes,favorited_result] = await Promise.all(api_promises);

    const locationDetailData = locationApiRes.data;
    
    if (favorited_result) {
      if (favorited_result.data.favorited_time) {
        set_followed(true)
      }
    }
    
    // JBB - this logic should be here. Also, using .reverse() below is incorrect - it reverses the order of the images displayed in Manage City (which is sorted alpha-numeric)
    let rotating_images = [];
    if (locationDetailData.city_skyline_wide_image_url) {
      rotating_images.push(locationDetailData.city_skyline_wide_image_url);
    } else if (locationDetailData.city_skyline_image_url) {
      rotating_images.push(locationDetailData.city_skyline_image_url);
    }
    if (locationDetailData.image_urls) {
      rotating_images = rotating_images.concat(locationDetailData.image_urls);
    }
    locationDetailData.rotating_images = rotating_images;
    
    set_city_detail_info(locationDetailData);

    const city_state_province = _get(locationApiRes, 'data.state_province', '');
    const city_country = _get(locationApiRes, 'data.country', '');
    const city_name = _get(locationApiRes, 'data.entity_name', '');
    let tmp_page_title = "PechaKucha "+city_name;
    if (city_state_province && city_state_province !== 'UNKNOWN') {
      tmp_page_title += ', '+city_state_province;
    }
    if (city_country && city_country  !== 'UNKNOWN') {
      tmp_page_title += ', '+city_country;
    }
    // set page title faster for Helmet/GA
    set_page_title(tmp_page_title)
    
    // Calling Events API
    showEvents(locationDetailData.entity_name, 'all', from, limit);

    // Blog/Organizer API
    const cityUsersData = cityUsersRes.data
    const organizerArr = cityUsersData && cityUsersData.length && cityUsersData.map(({ xref_data, entity_uuid, firstname,
      lastname, description, avatar_image_url, youtube_handle, facebook_handle, twitter_handle,
      website_url, status_code, friendly_url
    }) => {
        if (user_entity_uuid === entity_uuid && (xref_data && xref_data.entity_owner_integer >= 1) && user_Status === 1) {
          set_location_owner(true)
      }
      const found = cityUsersData.find(city => (city.xref_data && city.xref_data.entity_owner_integer === 1));
      if (!found) {
        set_no_organizer(true)
      }

      if (avatar_image_url !== undefined && !null) {
        let url = avatar_image_url;
        let array = url.split("/");
        avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}`
      }

      return {
        Organizer_firstname: firstname,
        Organizer_lastname: lastname,
        Organizer_text: description,
        avatar_image_url: avatar_image_url,
        entity_uuid: entity_uuid,
        youtube_handle: youtube_handle,
        facebook_handle: facebook_handle,
        twitter_handle: twitter_handle,
        website_url: website_url,
        status_code: status_code,
        friendly_url: friendly_url
      }
    
    })

    // Featured/Spotlighted Pk
    getSpotlightedPk();

    // Pk presentations
    getpkDetailData(locationDetailData.entity_name, locationDetailData.entity_uuid, 0, pk_detail_limit)

    //LCK RECENT PK presentations
    getRecentpkDetailData(locationDetailData.entity_name, locationDetailData.entity_uuid, 0, pk_recent_detail_limit)

    // To get Speakers
    getSpeakers(locationDetailData.entity_name, locationDetailData.entity_uuid);

    // set the all api data
    set_organizer_arr(organizerArr)
    set_loading(false)
  }

  const getMorePkDetailData = async function (location) {
    //console.log('getMorePkDetailData')
    console.log('getMorePkDetailData ARGUMENTS RECEIVED:', location);
    set_pk_more_data_loader(true)
    let updatedLimit = pk_detail_limit * 4;
    let updatedFrom = pk_detail_from + pk_detail_limit;
    // let new_from = from + current_limit
    // let new_limit = new_from + 12;
    // set_current_limit(12)
    // let updatedFrom = from + updatedLimit;
    // let new_from = from + current_limit;
    // let new_limit = current_limit
    // let new_from = from + updatedLimit;
    // let new_limit = updatedLimit
    //set_current_limit(12);

    // getpkDetailData(location, city_detail_info.entity_uuid, updatedFrom, updatedLimit)
    getpkDetailData(location, city_detail_info.entity_uuid, updatedFrom, updatedLimit)
  }
	//LCK adding function for more RECENT data
	const getMorePkRecentDetailData = async function (location) {
	  console.log('getMorePkRecentDetailData ARGUMENTS RECEIVED:', location);
    set_pk_recent_more_data_loader(true)
    //let updatedLimit = limit * 4;
    //let updatedFrom = from + 1;
    let updatedLimit = pk_recent_detail_limit * 4;
    let updatedFrom = pk_recent_detail_from + pk_recent_detail_limit;

    getRecentpkDetailData(location, city_detail_info.entity_uuid, updatedFrom, updatedLimit)
  }

  // API to get spotlighted PK
  const getSpotlightedPk = async function () {
    let spotlighted_pk_results = await axios.get(`${apiUrl}locations/${props.match.params.friendly_url}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`);

    const spotlightPk = spotlighted_pk_results.data[0];
    let spotlightPkPresenter = [];
    spotlightPk && spotlightPk.users && spotlightPk.users.length && spotlightPk.users.forEach(({ firstname, lastname, description, avatar_image_url, xref_data }) => {
      if (xref_data && xref_data.presenter_integer === 1) {
        spotlightPkPresenter.push({ firstname, lastname, description, avatar_image_url })
      }
    });
    
    set_spotlight_pk(spotlightPk)
    set_spotlight_pk_presenter(spotlightPkPresenter.length > 0 ? spotlightPkPresenter[0] : {})
    set_like_count(spotlightPk && spotlightPk.applaud_count)
  }

  // API to get all presentations
  const getpkDetailData = async function (location, location_uuid, from, limit) {
    console.log('getpkDetailData ARGUMENTS RECEIVED:', location, location_uuid, from, limit);
    const pkDataRes = await axios.get(`${search_Presentation_API}?get_presenter=true&locations_uuid=${location_uuid}&locations_text=${location}&sort_by=view_count&sort_order=DESC&from=${from}&limit=${limit}`, HeaderConfig);
    // const pkDataRes = await axios.get(`${search_Presentation_API}?get_presenter=true&locations_uuid=${location_uuid}&locations_text=${location}&sort_by=view_count&sort_order=DESC&from=${from}&limit=${current_limit}`, HeaderConfig);
    let pkDetailData = pkDataRes.data.search_query_results;
    // set_current_limit(12)

    if (pkDetailData.length === 0) {
      set_hide_more_pk_btn(true)
    }
    set_pk_detail_data(pk_detail_data.concat(pkDetailData))
    //set_pk_detail_from(pk_detail_data.length)
    set_pk_detail_from(from);
    set_pk_detail_limit(limit);
    set_pk_more_data_loader(false)
  }

    // LCK TESTING RECENT API to get all presentations
    const getRecentpkDetailData = async function (location, location_uuid, from, limit) {
      console.log('getRecentpkDetailData ARGUMENTS RECEIVED:', location, location_uuid, from, limit);
        const pkRecentDataRes = await axios.get(`${search_Presentation_API}?get_presenter=true&locations_uuid=${location_uuid}&locations_text=${location}&sort_by=created_time&sort_order=DESC&from=${from}&limit=${limit}`, HeaderConfig);
        let pkRecentDetailData = pkRecentDataRes.data.search_query_results;
				if (pkRecentDetailData.length === 0) {
          set_hide_more_pk_btn(true)
				}
        set_pk_recent_detail_data(pk_recent_detail_data.concat(pkRecentDetailData))
        //set_pk_recent_detail_from(pk_recent_detail_data.length)
        set_pk_recent_detail_from(from);
        set_pk_recent_detail_limit(limit);

        set_pk_recent_more_data_loader(false)
      }

  //API to get all Speakers in this event
  const getSpeakers = async function (locationsText,location_uuid) {
    let speakersList = [];
    const speakerSearchRes = await axios.get(`${searchUrl}eventsearch?locations_uuid=${location_uuid}&locations_text=${locationsText}&start_time_order=DESC&limit=20`);
    let speakerSearchData = speakerSearchRes.data.search_query_results;
    
    let api_promises = [];
    
    for (let tmp_event_obj of speakerSearchData) {
      let entity_info = tmp_event_obj.entity_info;
      api_promises.push(axios.get(`${events_list_api}/${entity_info.entity_uuid}/users?filter[presenter_integer][gte]=1`));      
    }
    
    let all_speakers_responses = await Promise.all(api_promises);
    
    let all_speakers = [];
    
    for (let event_speakers_response of all_speakers_responses) {
      for (let user_obj of event_speakers_response.data) {
        all_speakers.push(user_obj);
      }
    }

    let unique_speakers = all_speakers.filter((ele, ind) => ind === all_speakers.findIndex(elem => elem.entity_uuid === ele.entity_uuid));

    unique_speakers.forEach((item) => {
      if (item.avatar_image_url) {
        let url = item.avatar_image_url;
        let array = url.split("/");
        item.avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}`
      }
    })
    set_speakers_list(unique_speakers)
    set_presenters_total_limit(unique_speakers.length)
    set_presenters_current_limit(6)
  }

  // Remove limit showing presenters
  const showAllPresenters = async function () {
    // const { presentersTotalLimit } = this.state;
    set_presenters_current_limit(presenters_total_limit)
    set_hide_more_speaker_btn(true)
  }


  // Like And Unlike Method
  const handleClickLike = async () => {
    if (user_Status === 1) {
      // Applaud Count API starts
      set_like_loader(true)
      let decrement_flag = "";
      let new_label = 'unlike';
      if (label_like === 'unlike') {
        decrement_flag = "&decrement=true";
        new_label = 'like';
      }
      const likeLoaderAPI = await axios.post(`${presentation_Creation_API}/${city_detail_info.entity_uuid}/incrementCount?count_type=applaud${decrement_flag}`, {}, myHeaders_Autorized)
      if (likeLoaderAPI.data.message === "count not incremented - user has already done this action") {
        set_like_loader(false)
        return null;
      }
      set_like_count(likeLoaderAPI.data.new_count)
      set_label_like(new_label)
      set_like_loader(false)
      // now bust cache
      let audience_params = {
        attributes: ['entity_uuid']
      };
      axios.all([
        axios.get(`${apiUrl}locations/${city_detail_info.entity_uuid}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`, myHeaders_With_Cache_Control),
        axios.get(`${apiUrl}users/${user_entity_uuid}/presentations.audience`, { params: audience_params, ...myHeaders_Auth_With_Cache_Control })
      ]);
      // Applaud Count API ends 
    }
  }

  // Events Part starts
  const showMoreEvents = (past_or_future, city_name, from, limit) => {
    set_load_more_loader(true)
    showEvents(city_name, past_or_future, from, limit);
  }

  // see all events
  const showEvents = async (city_name, past_or_future, from, limit) => {

    let eventsData;
    let eventArr = [];
    let order;
    let start_or_end;
    let got_them_all = false;

    if (past_or_future === "future") {
      order = "ASC";
      start_or_end = "search_start_time=" + current_unix_stamp + "&";
    } else if (past_or_future === "past") {
      order = "DESC";
      start_or_end = "search_end_time=" + current_unix_stamp + "&";
    } else {
      // all
      order = "DESC";
      start_or_end = "";
    }


    eventsData = await axios.get(`${searchUrl}eventsearch?${start_or_end}start_time_order=${order}&locations_text=${city_name}&from=${from}&limit=${limit}`, HeaderConfig);
    if (!eventsData || !eventsData.data || !eventsData.data.search_query_results || eventsData.data.search_query_results.length < limit) {
      got_them_all = true;
    }


    if (eventsData.data && eventsData.data.search_query_results && eventsData.data.search_query_results.length > 0) {
      for (let item of eventsData.data.search_query_results) {
        let entity = item.entity_info;
        let venues_data = "";
        const start_time = unixDateConversion(entity.start_time);
        const start_time_conv = dateConvert(start_time)
        let time_slot = start_time_conv.hour;
        var selectedDate = start_time;

        let days_left;
        if (selectedDate > new Date()) {
          let day_diff = DaysDiff(start_time);
          let hour_diff = HoursDiff(start_time);
          days_left = "Starts in " + day_diff + " days, " + hour_diff + " hours";
        } else {
          days_left = "Completed";
        }

        eventArr.push({
          entity_name: entity.entity_name,
          friendly_url: entity.friendly_url,
          entity_uuid: entity.entity_uuid,
          event_days_left: days_left,
          thumb_image_url: entity.thumb_image_url || null,
          poster_image_url: entity.poster_image_url,
          locations_text: entity.locations_text,
          Event_month: start_time_conv.month,
          Event_year: start_time_conv.year,
          Event_day: start_time_conv.day,
          Event_date: start_time_conv.date,
          Event_slot: time_slot,
          volume_integer: entity.volume_integer,
          Events_venue: venues_data
        });
      }
    }


    let new_limit = limit * 4;
    if (new_limit > 200) {
      new_limit = 200;
    }

    if (past_or_future === "future") {
      set_got_all_future(got_them_all)
      set_future_event_arr(future_event_arr.concat(eventArr) )
    } else if (past_or_future === "past") {
      set_got_all_past(got_them_all)
      set_past_event_arr(past_event_arr.concat(eventArr))
    } else {
      set_got_all_all(got_them_all)
      set_all_event_arr(all_event_arr.concat(eventArr))
    }
    
    set_load_more_loader(false)
    set_from(limit)
    set_limit(new_limit)
    set_events_loading(false);
  } // END SHOW EVENTS FUNCTION
  // Events part ends here

  
  // Events Pk Data
  const eventsList = (eventArr) => {
    return (
        <Row>
          {
            eventArr.map((item) => {
              return (
                
                <Col md={6} lg={4} xl={4} key={item.entity_uuid}>
                  <UpcomingEventsCom
                    key={item.entity_uuid} id={item.entity_uuid}
                    Event_img={item.thumb_image_url || item.poster_image_url}
                    Event_title={item.entity_name}
                    Event_year={item.Event_year}
                    Event_time={item.event_days_left} Event_month={item.Event_month}
                    Event_date={item.Event_date}
                    Event_place={item.locations_text}
                    Event_vol={item.volume_integer} Event_slot={item.Event_slot} Event_venues={item.Events_venue}
                    Event_link={`${local_routes.events}/${item.friendly_url}`}
                  />
                </Col>
             
              )
            }
            )}
        </Row>
    );
  };

//LCK funciton for changing state of toggle switch
  const onSwitchAction = () => {
    if (is_switch_on) {
      set_is_switch_on(false)
      props.history.push('?show_pks_toggle=trending')
    } else {
      set_is_switch_on(true)
      props.history.push('?show_pks_toggle=recent')
    }
  };

  
  
		//console.log("****MY STATE SWITCH BOOLEAN***", is_switch_on)
    const { city_name, description, facebook_handle, twitter_handle, instagram_handle, youtube_handle } = city_detail_info;
    const imagesList = city_detail_info.rotating_images;

    let { match: { params: { friendly_url } = {} } = {} } = props
    friendly_url = friendly_url.toLowerCase();

    if (loading) {
      return (
          <React.Fragment>
            <Helmet defer={false}>
              <title>{page_title}</title>
              <meta name="description" content={`PechaKucha ${city_name}: Events and Presentations. All in 20x20 Pecha Kucha format.`} />
              <meta property="og:type" content="website" />
              <meta property="og:url" content={`https://www.pechakucha.com${local_routes.cities}/${friendly_url}`} />
              <meta property="og:title" content={page_title} />
              <meta property="og:description" content={`PechaKucha ${city_name}: Events and Presentations. All in 20x20 Pecha Kucha format.`} />
            </Helmet>
            <ActivityIndicator theme="spinner" />
          </React.Fragment>
      )
    }
    else {
      return (
        <div className="main-section new-city-section">
          <React.Fragment>
            <Helmet defer={false}>
              <title>{page_title}</title>
              <meta name="description" content={`PechaKucha ${city_name}: Events and Presentations. All in 20x20 Pecha Kucha format.`} />
              <meta property="og:type" content="website" />
              <meta property="og:url" content={`https://www.pechakucha.com${local_routes.cities}/${friendly_url}`} />
              <meta property="og:title" content={page_title} />
              <meta property="og:description" content={`PechaKucha ${city_name}: Events and Presentations. All in 20x20 Pecha Kucha format.`} />
            </Helmet>

            {/* Banner section starts */}
            <CityBanner
              followed={followed}
              city_info={city_detail_info}
              carouselImage={imagesList || []}
              CityImage={CityImage}
              logoCity={logoCity}
              cityName={city_name}
              cityDes={description}
              locationOwner={location_owner}
              facebookHandle={facebook_handle}
              twitterHandle={twitter_handle}
              instagramHandle={instagram_handle}
              youtubeHandle={youtube_handle}
              noOrganizer={no_organizer}
              friendly_url={city_detail_info.friendly_url}
              openCityHeading={'This City is Open - Apply Now!'}
              openCityDes={'If you think you have what it takes to run PechaKucha Nights in your city, apply to become the official organizer!'} />
            {/* Banner section Ends */}

            {/* Upcoming Events Section Starts Here */}
              <div className="marBot20">
                <Container>
                  <h1 className="city-heading">PechaKucha {city_name}</h1>
                  <TitleSection
                    title="Upcoming & Recent Events"
                    seeAll="false"
                    //seeAll={cityArr.length > 0 ? "false" : "false"}
                    Title_link="#"
                  />
                 {all_event_arr.length > 0 ?
                 <React.Fragment>
                  {eventsList(all_event_arr)}
                  {!got_all_all &&
                    <div>
                      {load_more_loader === true ?
                        <ActivityIndicator theme="spinnerNoMargin" />
                        :
                        <p style={{ textAlign: 'center', marginTop: '20px', marginBottom: 40, color: '#fff' }}><span onClick={() => showMoreEvents('all', city_name, from, limit)} className="loadmore-btn">Show More Events</span></p>
                      }
                    </div>
                  }
                  </React.Fragment>
                  :
                  <React.Fragment>
                  {!events_loading &&
                    <EmptyUpcomingEvents emptyEventImg={emptyEventImg} noEventHeading={"There haven't been any events in this city yet."}
                      addCityHeading={'Would you like to see a PechaKucha Night event in your city?'}
                      applyCityDescription={"If you think you have what it takes to run PechaKucha Night in your city, apply to become the official organizer! Join the celebration of cretivity by becoming part of our global network of volunteers and put your city's creative talent and hidden heroeson the world stage!"}
                    />
                  }
                  </React.Fragment>
                }
                </Container>
              </div>
             
            {/* Upcoming Events Section Ends Here */}

            {/* Presentation Section Starts Here */}
            {
              spotlight_pk && spotlight_pk.presentation_video_url &&
              <SpotLightPk
                city_or_channel_name={city_name}
                //presentation_data={spotlightPk.presentation_video_url}
                entity_name={spotlight_pk.entity_name}
                description={spotlight_pk.description}
                avatar_image_url={spotlight_pk_presenter && spotlight_pk_presenter.avatar_image_url && spotlight_pk_presenter.avatar_image_url}
                firstName={spotlight_pk_presenter.firstname}
                lastName={spotlight_pk_presenter.lastname}
                designation={spotlight_pk_presenter.description}
                full_name={(spotlight_pk_presenter.firstname && spotlight_pk_presenter.lastname) ? `${spotlight_pk_presenter.firstname} ${spotlight_pk_presenter.lastname}` : (spotlight_pk_presenter.firstname) ? `${spotlight_pk_presenter.firstname}` : ''}
                presenter_friendly_url={spotlight_pk.friendly_url}
                friendly_url={spotlight_pk.friendly_url}
                mailTo="mailto:support@pechakucha.org"
                textReport="Report"
                iconName="fa fa-flag"
                iconNameLike="fa fa-heart"
                noOfLikes={like_count}
                handleClick={handleClickLike}
                likeLabel={label_like}
                presentation_data={spotlight_pk}
                likeLoader={like_loader}
              />
            }

            {/* Presentation Section Ends Here */}
						<Container className="mt-3">
							<Row className="justify-content-between wrap">
								<Col md={7}>
									{(is_switch_on === false)?(
										<h2 className="mt-2">{`Trending PechaKucha ${city_name} Presentations`}</h2>
									):(
										<h2 className="mt-2">{`Recent PechaKucha ${city_name} Presentations`}</h2>
									)}
								</Col>
								<Col xs={6} md={4}>
									{pk_detail_data.length>0?(<Form className="mt-3 ml-5" >
									<Form.Switch
									  className="ml-2"
									  style={{transform: "scale(1.5)", color: 'black'}}
										onChange={onSwitchAction}
										id="custom-switch"
										label={
                      <span> 
                        <span style={{ fontWeight: is_switch_on ? 'lighter' : 'bold'}}>Trending </span> 
                        <span style={{ fontWeight: 'lighter', fontStyle: 'italic' }}>or </span> 
                        <span style={{ fontWeight: is_switch_on ?  'bold' : 'lighter'}}>Recent</span>
                      </span>
                    }
										checked={is_switch_on}
									/>
									</Form>):(null)}
								</Col>
							</Row>
						</Container>

            {/* Trending Presentation Section Starts Here */}
						{(is_switch_on === false) ? (
								pk_detail_data.length > 0 &&
								<div className="container">
									<div className="city-presentation-section presentation-section">
										<div>
											<Row>
												{
													pk_detail_data.map((item, index) => {
														let itemField = item.entity_info;
														return (
															<Col lg={4} sm={12} md={6} key={index}>
															 <PresentationCard
																		key={itemField.entity_uuid}
																		presentation_info={itemField}
																/> 
															</Col>
														)
													}
	
													)}
											</Row>
											{
												pk_more_data_loader === false ?
													<React.Fragment>
														{
															hide_more_pk_btn === false &&
															<div className="show-more-btn">
																<Button OnClickMet={() => getMorePkDetailData(city_name)} theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket" style={{ width: 'auto' }}>
																	Show More Presentations
															 </Button>
															</div>
														}
													</React.Fragment>
													:
													<div className="show-more-btn">
														<ActivityIndicator theme="spinner show-more-spinner" />
													</div>
											}
										</div>
									</div>
								</div>							
							// /* Trending Presentation Section Ends Here */

						):(

							//** RECENT presentations section starts here*/
							pk_recent_detail_data.length > 0 &&
								<div className="container">
									<div className="city-presentation-section presentation-section">
										<div>
											<Row>
												{
													pk_recent_detail_data.map((item, index) => {
														let itemField = item.entity_info;
														return (
															<Col lg={4} sm={12} md={6} key={index}>
															 <PresentationCard
																		key={itemField.entity_uuid}
																		presentation_info={itemField}
																/>                            																
															</Col>
														)
													}
	
													)}
											</Row>
											{
												pk_recent_more_data_loader === false ?
													<React.Fragment>
														{
															hide_more_pk_recent_btn === false &&
															<div className="show-more-btn">
																<Button OnClickMet={() => getMorePkRecentDetailData(city_name)} theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket" style={{ width: 'auto' }}>
																	Show More Presentations
															 </Button>
															</div>
														}
													</React.Fragment>
													:
													<div className="show-more-btn">
														<ActivityIndicator theme="spinner show-more-spinner" />
													</div>
											}
										</div>
									</div>
								</div>
								//**End RECENT SECTION HERE */
						)}
            
            {/* Event Speakers Section Starts Here */}
            {speakers_list.length > 0 &&
              <div className="container">
                <div className=" presentation-section speakers-section">
                  <TitleSection title={`${city_name} Speakers`} />
                  <div>
                    <Row>
                      {
                        speakers_list.slice(0, presenters_current_limit).map((item, index) =>
                          <Col key={index} sm={12} md={6} lg={6}>
                            <Organizer
                              show_Icon={false}
                              Organizer_firstname={item.firstname}
                              Organizer_lastname={item.lastname}
                              Organizer_text={item.description}
                              profile_pic={item.avatar_image_url}
                              Organizer_link={
                                (item.friendly_url !== undefined && item.friendly_url !== null && item.status_code === 1) ? `${local_routes.users}/${item.friendly_url}`
                                : null
                              }
                            />
                          </Col>
                        )}
                    </Row>
                    {
                      presenters_total_limit > 6 && hide_more_speaker_btn === false &&
                      <div className="show-more-btn">
                        <Button OnClickMet={() => showAllPresenters()} theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket" style={{ width: 'auto' }}>
                          Show More Speakers
                    </Button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }

            {/* Organizers Section Starts Here */}
            {
              organizer_arr.length > 0 &&
              <div className="container">
                <div className="city-organizers-section speakers-section">
                  <TitleSection title= {`${city_name} Organizers`} />
                  <div>
                    <Row>
                      {
                        organizer_arr.map((item) =>
                          <Col key={item.entity_uuid} sm={6}>
                            <Organizer
                              show_Icon={true}
                              Organizer_firstname={item.Organizer_firstname}
                              Organizer_lastname={item.Organizer_lastname}
                              profile_pic={item.avatar_image_url}
                              Organizer_text={item.Organizer_text}
                              twitter_handle={item.twitter_handle}
                              facebook_handle={item.facebook_handle}
                              website_url={item.website_url}
                              youtube_handle={item.youtube_handle}
                              Organizer_link={(item.friendly_url !== undefined && !null) && (item.status_code === 1) &&
                                `${local_routes.users}/${item.friendly_url}`}
                            />
                          </Col>
                        )}
                    </Row>
                  </div>
                </div>
              </div>

            }

            {/* Organizer ends */}


            <Footer
              homeImg={home}
              homeImgRef="/"
              breadcrumbSubPage="City"
            />
          </React.Fragment>

        </div>
      )
    }

  }



export default City;

// 
// 
// 
// 
// import React from 'react';
// import _get from 'lodash/get';
// import { Helmet } from "react-helmet";
// import './style.css';
// import Footer from 'components/Footer/Footer';
// import Button from 'components/Button/Button';
// import CityImage from 'Assets/events-hero.png';
// import { local_routes } from 'utils/Routes';
// import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
// import home from 'Assets/home.svg';
// import logoCity from 'Assets/logo-city.png';
// import Col from 'react-bootstrap/Col';
// import Row from 'react-bootstrap/Row';
// import Form from 'react-bootstrap/Form';
// import CityBanner from 'components/Banner/CityBanner';
// import TitleSection from 'components/TitleBar/TitleSection';
// import UpcomingEventsCom from 'components/UpcomingEvents/UpcomingEvents';
// import EmptyUpcomingEvents from 'components/CityUpcomingEvents/EmptyUpcomingEvents';
// import SpotLightPk from 'components/spotlightedPK/spotlightedPK';
// import axios from 'axios';
// import Container from 'react-bootstrap/Container';
// import { current_unix_stamp, unixDateConversion, dateConvert, DaysDiff, HoursDiff } from 'utils/Helper';
// import { searchUrl, events_list_api, apiUrl, HeaderConfig, search_Presentation_API, user_entity_uuid, presentation_Creation_API, user_Status, myHeaders_Autorized, myHeaders_Auth_With_Cache_Control, myHeaders_With_Cache_Control } from "Api/Api";
// //import Trending from 'components/TrendingNow/Trending';
// import PresentationCard from "components/PresentationCard/PresentationCard";
// import Organizer from 'components/Organizers/Organizers';
// import emptyEventImg from 'Assets/upcoming-events.png';

// class City extends React.Component {
//   state = {
//     followed: false,
//     loading: true,

//     likeLoader: false,
//     likeCount: 0,
//     labelLike: 'like',
//     page_title: 'PechaKucha 20x20',

//     cityDetailInfo: {},
//     locationOwner: false,
//     organizerArr: {},
//     noOrganizer: false,
//     spotlightPk: {},
//     spotlightPkPresenter: {},

//     past_eventArr: [],
//     future_eventArr: [],
//     all_eventArr: [],
//     from: 0,
//     limit: 3,
//     gotAllPast: false,
//     gotAllFuture: false,
//     gotAllAll: false,
//     loadMoreLoader: false,

//     pkDetailData: [],
//     pkDetailFrom: 0,
//     pkDetailLimit: 3,
//     pkMoreDataLoader: false,
//     hideMorePkBtn: false,

//     speakersList: [],
//     presentersTotalLimit: 0,
//     presentersCurrentLimit: 6,
//     hideMoreSpeakerBtn: false,

// 		//toggle recent
// 		isSwitchOn: false,
// 		//Recent State
// 		pkRecentDetailData: [],
//     pkRecentDetailFrom: 0,
//     pkRecentDetailLimit: 3,
//     pkRecentMoreDataLoader: false,
//     hideMorePkRecentBtn: false
//   }

//     componentDidUpdate (prevProps) {
//         let { location: { pathname } } = this.props;

//         if (prevProps.location.pathname === pathname) return;
//         this.routeChanged();
//     }

//     routeChanged () {
//       this.setState({
//         from: 0,
//         limit: 3,
//         all_eventArr: [],
//         past_eventArr: [],
//         future_eventArr: []
//       },this.APICalls);
//         //this.APICalls();
//     }

//     componentDidMount() {
// 			//this loads recent videos for each city when the page loads
// 			if(this.props.location.search === "?show_pks_toggle=recent"){
// 				this.setState({isSwitchOn: true})
// 				//this loads the page defaulting to the regular pathname
// 			}else if (this.props.location.search === "?show_pks_toggle=trending"){
// 			  this.props.history.push(this.props.location.pathname)
// 			}
//         this.routeChanged();
//     }

//   // Component Did Mount
//   APICalls = async function () {
//     let { match: { params: { friendly_url } = {} } = {} } = this.props
//     friendly_url = friendly_url.toLowerCase();
//     //const locationApiRes = await axios.get(`${apiUrl}locations/${friendly_url}`, myHeaders_With_Cache_Control)
//     let api_promises = [];
//     api_promises.push(axios.get(`${apiUrl}locations/${friendly_url}`));
//     api_promises.push(axios.get(`${apiUrl}locations/${friendly_url}/users`));
//     //api_promises.push(axios.get(`${apiUrl}locations/${friendly_url}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`));
//     if (user_Status === 1) {
//       api_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience/${friendly_url}`, myHeaders_Auth_With_Cache_Control));
//     }  
//     //const [locationApiRes,spotlightPkRes,favorited_result] = await Promise.all(api_promises);
//     const [locationApiRes,cityUsersRes,favorited_result] = await Promise.all(api_promises);
//     const locationDetailData = locationApiRes.data;
    
//     if (favorited_result) {
//       if (favorited_result.data.favorited_time) {
//         this.setState({ followed: true });
//       }
//     }
//     /*    
//     if (user_Status === 1) {
//       try {
//         let favorited_result = await axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience/${locationDetailData.entity_uuid}`, myHeaders_Auth_With_Cache_Control);
//         console.log("favorited_result",favorited_result.data);
//         if (favorited_result.data.favorited_time) {
//           this.setState({ followed: true });
//         }
//       } catch (err) {
//         // this is ok if we get a 404 here
//       }
      
//     }
//     */
    
//     // JBB - this logic should be here. Also, using .reverse() below is incorrect - it reverses the order of the images displayed in Manage City (which is sorted alpha-numeric)
//     let rotating_images = [];
//     if (locationDetailData.city_skyline_wide_image_url) {
//       rotating_images.push(locationDetailData.city_skyline_wide_image_url);
//     } else if (locationDetailData.city_skyline_image_url) {
//       rotating_images.push(locationDetailData.city_skyline_image_url);
//     }
//     if (locationDetailData.image_urls) {
//       rotating_images = rotating_images.concat(locationDetailData.image_urls);
//     }
//     locationDetailData.rotating_images = rotating_images;
    
//     this.setState({ cityDetailInfo: locationDetailData })
//     const city_state_province = _get(locationApiRes, 'data.state_province', '');
//     const city_country = _get(locationApiRes, 'data.country', '');
//     const city_name = _get(locationApiRes, 'data.entity_name', '');
//     let tmp_page_title = "PechaKucha "+city_name;
//     if (city_state_province && city_state_province !== 'UNKNOWN') {
//       tmp_page_title += ', '+city_state_province;
//     }
//     if (city_country && city_country  !== 'UNKNOWN') {
//       tmp_page_title += ', '+city_country;
//     }
//     // set page title faster for Helmet/GA
//     this.setState({ page_title: tmp_page_title });
    
//     // Calling Events API
//     this.showEvents(locationDetailData.entity_name, 'all', this.state.from, this.state.limit);
//     // Blog/Organizer API
//     //const cityUsersRes = await axios.get(`${apiUrl}locations/${locationDetailData.entity_uuid}/users`, myHeaders_With_Cache_Control);
//     //const cityUsersRes = await axios.get(`${apiUrl}locations/${locationDetailData.entity_uuid}/users`);
//     const cityUsersData = cityUsersRes.data
//     const organizerArr = cityUsersData && cityUsersData.length && cityUsersData.map(({ xref_data, entity_uuid, firstname,
//       lastname, description, avatar_image_url, youtube_handle, facebook_handle, twitter_handle,
//       website_url, status_code, friendly_url
//     }) => {
//         if (user_entity_uuid === entity_uuid && (xref_data && xref_data.entity_owner_integer >= 1) && user_Status === 1) {
//         this.setState({ locationOwner: true })
//       }
//       const found = cityUsersData.find(city => (city.xref_data && city.xref_data.entity_owner_integer === 1));
//       if (!found) {
//         this.setState({ noOrganizer: true })
//       }
//       if (avatar_image_url !== undefined && !null) {
//         let url = avatar_image_url;
//         let array = url.split("/");
//         avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}`
//       }
//       return {
//         Organizer_firstname: firstname,
//         Organizer_lastname: lastname,
//         Organizer_text: description,
//         avatar_image_url: avatar_image_url,
//         entity_uuid: entity_uuid,
//         youtube_handle: youtube_handle,
//         facebook_handle: facebook_handle,
//         twitter_handle: twitter_handle,
//         website_url: website_url,
//         status_code: status_code,
//         friendly_url: friendly_url
//       };
//     });
//     // Featured/Spotlighted Pk
//     this.getSpotlightedPk();
//     /*
//     const spotlightPk = spotlightPkRes.data[0];
//     let spotlightPkPresenter = [];
//     spotlightPk && spotlightPk.users && spotlightPk.users.length && spotlightPk.users.forEach(({ firstname, lastname, description, avatar_image_url, xref_data }) => {
//       if (xref_data && xref_data.presenter_integer === 1) {
//         spotlightPkPresenter.push({ firstname, lastname, description, avatar_image_url })
//       }
//     });
//     */
//     // Pk presentations
//     this.getpkDetailData(locationDetailData.entity_name, locationDetailData.entity_uuid, 0, this.state.pkDetailLimit)
//     //LCK RECENT PK presentations
//     this.getRecentpkDetailData(locationDetailData.entity_name, locationDetailData.entity_uuid, 0, this.state.pkRecentDetailLimit)
//     // To get Speakers
//     this.getSpeakers(locationDetailData.entity_name, locationDetailData.entity_uuid);
//     // set the all api data
//     this.setState({
//       //spotlightPk,
//       //spotlightPkPresenter: spotlightPkPresenter.length > 0 ? spotlightPkPresenter[0] : {},
//       organizerArr,
//       //likeCount: spotlightPk && spotlightPk.applaud_count,
//       //page_title:tmp_page_title // do this earlier
//       loading: false
//     });
//     // }
    
//     // Stop Loading at the end
//     //this.setState({ loading: false })
//   }
//   getMorePkDetailData = async function (location, from, limit) {
//     console.log('ARGS1:', location, from, limit)
//     this.setState({ pkMoreDataLoader: true })
//     let updatedLimit = limit * 4;
//     let updatedFrom = from + 1;
//     this.getpkDetailData(location, this.state.cityDetailInfo.entity_uuid, updatedFrom, updatedLimit)
//   }
// 	//LCK adding function for more RECENT data
// 	getMorePkRecentDetailData = async function (location, from, limit) {
//     this.setState({ pkRecentMoreDataLoader: true })
//     let updatedLimit = limit * 4;
//     let updatedFrom = from + 1;
//     this.getRecentpkDetailData(location, this.state.cityDetailInfo.entity_uuid, updatedFrom, updatedLimit)
//   }
//   // API to get spotlighted PK
//   getSpotlightedPk = async function () {
//     let spotlighted_pk_results = await axios.get(`${apiUrl}locations/${this.props.match.params.friendly_url}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`);
//     const spotlightPk = spotlighted_pk_results.data[0];
//     let spotlightPkPresenter = [];
//     spotlightPk && spotlightPk.users && spotlightPk.users.length && spotlightPk.users.forEach(({ firstname, lastname, description, avatar_image_url, xref_data }) => {
//       if (xref_data && xref_data.presenter_integer === 1) {
//         spotlightPkPresenter.push({ firstname, lastname, description, avatar_image_url })
//       }
//     });
    
//     this.setState({
//       spotlightPk,
//       spotlightPkPresenter: spotlightPkPresenter.length > 0 ? spotlightPkPresenter[0] : {},
//       likeCount: spotlightPk && spotlightPk.applaud_count
//     });
//   }
//   // API to get all presentations
//   getpkDetailData = async function (location, location_uuid, from, limit) {
//     console.log('ARGS2:', location, location_uuid, from, limit)
//     const pkDataRes = await axios.get(`${search_Presentation_API}?get_presenter=true&locations_uuid=${location_uuid}&locations_text=${location}&sort_by=view_count&sort_order=DESC&from=${from}&limit=${limit}`, HeaderConfig);
//     let pkDetailData = pkDataRes.data.search_query_results;
//     console.log("THIS MY PK DATA", pkDetailData)
//     if (pkDetailData.length === 0) {
//       this.setState({ hideMorePkBtn: true, })
//     }
//     this.setState({ pkDetailData: this.state.pkDetailData.concat(pkDetailData) })
//     this.setState({ pkDetailFrom: this.state.pkDetailData.length, pkMoreDataLoader: false })
//   }
//     // LCK TESTING RECENT API to get all presentations
//     getRecentpkDetailData = async function (location, location_uuid, from, limit) {
//         const pkRecentDataRes = await axios.get(`${search_Presentation_API}?get_presenter=true&locations_uuid=${location_uuid}&locations_text=${location}&sort_by=created_time&sort_order=DESC&from=${from}&limit=${limit}`, HeaderConfig);
//         let pkRecentDetailData = pkRecentDataRes.data.search_query_results;
//         console.log("THIS MY RECENT PK DATA", pkRecentDetailData)
// 				if (pkRecentDetailData.length === 0) {
// 					this.setState({ hideMorePkBtn: true, })
// 				}
// 				this.setState({ pkRecentDetailData: this.state.pkRecentDetailData.concat(pkRecentDetailData) })
// 				this.setState({ pkRecentDetailFrom: this.state.pkRecentDetailData.length, pkRecentMoreDataLoader: false })
//       }
//   //API to get all Speakers in this event
//   getSpeakers = async function (locationsText,location_uuid) {
//     let speakersList = [];
//     //const speakerSearchRes = await axios.get(`${searchUrl}eventsearch?locations_text=${locationsText}&start_time_order=DESC&limit=20`, myHeaders_With_Cache_Control);
//     const speakerSearchRes = await axios.get(`${searchUrl}eventsearch?locations_uuid=${location_uuid}&locations_text=${locationsText}&start_time_order=DESC&limit=20`);
//     let speakerSearchData = speakerSearchRes.data.search_query_results;
    
//     let api_promises = [];
    
//     for (let tmp_event_obj of speakerSearchData) {
//       let entity_info = tmp_event_obj.entity_info;
//       api_promises.push(axios.get(`${events_list_api}/${entity_info.entity_uuid}/users?filter[presenter_integer][gte]=1`));      
//     }
    
//     let all_speakers_responses = await Promise.all(api_promises);
    
//     let all_speakers = [];
    
//     for (let event_speakers_response of all_speakers_responses) {
//       for (let user_obj of event_speakers_response.data) {
//         all_speakers.push(user_obj);
//       }
//     }
//     //console.log("ALL SPEAKERS",all_speakers);
//     let unique_speakers = all_speakers.filter((ele, ind) => ind === all_speakers.findIndex(elem => elem.entity_uuid === ele.entity_uuid));
//     //console.log("UNIQUE SPEAKERS",unique_speakers);
//     unique_speakers.forEach((item,index,thisArray) => {
//       //console.log("AVATAR IMGAE URL",item.avatar_image_url);
//       if (item.avatar_image_url) {
//         let url = item.avatar_image_url;
//         let array = url.split("/");
//         item.avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}`
//       }
//     })
//     this.setState({ speakersList: unique_speakers, presentersTotalLimit: unique_speakers.length, presentersCurrentLimit: 6 })
    
//     /*
//     speakerSearchData.map(async ({ entity_info }) => {
//       const speakerRes = await axios.get(`${events_list_api}/${entity_info.entity_uuid}/users?filter[presenter_integer][gte]=1`, myHeaders_With_Cache_Control);
      
//       speakerRes.data.map(async (item) => {
//         speakersList.push(item)
//         let filterDuplicatePeople = speakersList.filter((ele, ind) => ind === speakersList.findIndex(elem => elem.entity_uuid === ele.entity_uuid));
//         console.log("HMM",filterDuplicatePeople)
//         filterDuplicatePeople.forEach((item,index,thisArray) => {
//           //console.log("AVATAR IMGAE URL",item.avatar_image_url);
//           if (item.avatar_image_url) {
//             let url = item.avatar_image_url;
//             let array = url.split("/");
//             //filterDuplicatePeople[index].avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}`
//           }
//         })
//       })
//         this.setState({ speakersList: filterDuplicatePeople, presentersTotalLimit: filterDuplicatePeople.length, presentersCurrentLimit: 6 })
      
//     })
//     */
//   }
//   // Remove limit showing presenters
//   showAllPresenters = async function () {
//     const { presentersTotalLimit } = this.state;
//     this.setState({ presentersCurrentLimit: presentersTotalLimit, hideMoreSpeakerBtn: true })
//   }
//   // Like And Unlike Method
//   handleClickLike = async () => {
//     const { labelLike, cityDetailInfo } = this.state;
//     if (user_Status === 1) {
//       // Applaud Count API starts
//       this.setState({ likeLoader: true });
//       let decrement_flag = "";
//       let new_label = 'unlike';
//       if (labelLike === 'unlike') {
//         decrement_flag = "&decrement=true";
//         new_label = 'like';
//       }
//       const likeLoaderAPI = await axios.post(`${presentation_Creation_API}/${cityDetailInfo.entity_uuid}/incrementCount?count_type=applaud${decrement_flag}`, {}, myHeaders_Autorized)
//       if (likeLoaderAPI.data.message === "count not incremented - user has already done this action") {
//         this.setState({ likeLoader: false });
//         return null;
//       }
//       this.setState({ likeCount: likeLoaderAPI.data.new_count, labelLike: new_label, likeLoader: false });
//       // now bust cache
//       axios.all([
//         //axios.get(`${apiUrl}locations/${cityDetailInfo.entity_uuid}/presentations?sort[spotlighted_time]=desc&limit=1`, myHeaders_With_Cache_Control),
//         axios.get(`${apiUrl}locations/${cityDetailInfo.entity_uuid}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`, myHeaders_With_Cache_Control),
//         axios.get(`${apiUrl}users/${user_entity_uuid}/presentations.audience`, myHeaders_Auth_With_Cache_Control)
//       ]);
//       // Applaud Count API ends 
//     }
//   }
//   // Events Part starts
//   showMoreEvents = (past_or_future, city_name, from, limit) => {
//     this.setState({ loadMoreLoader: true });
//     this.showEvents(city_name, past_or_future, from, limit);
//   }
//   // see all events
//   showEvents = async (city_name, past_or_future, from, limit) => {
//     let eventsData;
//     let eventArr = [];
//     let order;
//     let start_or_end;
//     let got_them_all = false;
//     if (past_or_future === "future") {
//       order = "ASC";
//       start_or_end = "search_start_time=" + current_unix_stamp + "&";
//     } else if (past_or_future === "past") {
//       order = "DESC";
//       start_or_end = "search_end_time=" + current_unix_stamp + "&";
//     } else {
//       // all
//       order = "DESC";
//       start_or_end = "";
//     }

//     eventsData = await axios.get(`${searchUrl}eventsearch?${start_or_end}start_time_order=${order}&locations_text=${city_name}&from=${from}&limit=${limit}`, HeaderConfig);
//     if (!eventsData || !eventsData.data || !eventsData.data.search_query_results || eventsData.data.search_query_results.length < limit) {
//       got_them_all = true;
//     }

//     if (eventsData.data && eventsData.data.search_query_results && eventsData.data.search_query_results.length > 0) {
//       for (let item of eventsData.data.search_query_results) {
//         let entity = item.entity_info;
//         let venues_data = "";
//         const start_time = unixDateConversion(entity.start_time);
//         const start_time_conv = dateConvert(start_time)
//         let time_slot = start_time_conv.hour;
//         var selectedDate = start_time;

//         let days_left;
//         if (selectedDate > new Date()) {
//           let day_diff = DaysDiff(start_time);
//           let hour_diff = HoursDiff(start_time);
//           days_left = "Starts in " + day_diff + " days, " + hour_diff + " hours";
//         } else {
//           days_left = "Completed";
//         }

//         eventArr.push({
//           entity_name: entity.entity_name,
//           friendly_url: entity.friendly_url,
//           entity_uuid: entity.entity_uuid,
//           event_days_left: days_left,
//           thumb_image_url: entity.thumb_image_url || null,
//           poster_image_url: entity.poster_image_url,
//           locations_text: entity.locations_text,
//           Event_month: start_time_conv.month,
//           Event_year: start_time_conv.year,
//           Event_day: start_time_conv.day,
//           Event_date: start_time_conv.date,
//           Event_slot: time_slot,
//           volume_integer: entity.volume_integer,
//           Events_venue: venues_data
//         });
//       }
//     }

//     let new_limit = limit * 4;
//     if (new_limit > 200) {
//       new_limit = 200;
//     }

//     if (past_or_future === "future") {
//       this.setState({ loadMoreLoader: false, gotAllFuture: got_them_all, from: limit, limit: new_limit, future_eventArr: this.state.future_eventArr.concat(eventArr) });
//     } else if (past_or_future === "past") {
//       this.setState({ loadMoreLoader: false, gotAllPast: got_them_all, from: limit, limit: new_limit, past_eventArr: this.state.past_eventArr.concat(eventArr) });
//     } else {
//       this.setState({ loadMoreLoader: false, gotAllAll: got_them_all, from: limit, limit: new_limit, all_eventArr: this.state.all_eventArr.concat(eventArr) });
//     }
//   }
//   // Events part ends here

//   // Events Pk Data
//   eventsList = (eventArr) => {
//     return (
//         <Row>
//           {
//             eventArr.map((item) => {
//               return (
//                 <Col md={6} lg={4} xl={4} key={item.entity_uuid}>
//                   <UpcomingEventsCom
//                     key={item.entity_uuid} id={item.entity_uuid}
//                     Event_img={item.thumb_image_url || item.poster_image_url}
//                     Event_title={item.entity_name}
//                     Event_year={item.Event_year}
//                     Event_time={item.event_days_left} Event_month={item.Event_month}
//                     Event_date={item.Event_date}
//                     Event_place={item.locations_text}
//                     Event_vol={item.volume_integer} Event_slot={item.Event_slot} Event_venues={item.Events_venue}
//                     Event_link={`${local_routes.events}/${item.friendly_url}`}
//                   />
//                 </Col>
//               )
//             }
//             )}
//         </Row>
//     );
//   };

// //LCK funciton for changing state of toggle switch
//  onSwitchAction =()=>{
// 	if(this.state.isSwitchOn === true){
// 		this.setState({isSwitchOn: false})
// 		this.props.history.push('?show_pks_toggle=trending')

// 	}else{
// 		this.setState({isSwitchOn: true})
// 		this.props.history.push('?show_pks_toggle=recent')
// 	}
// }


//   render() {
// 		console.log("****MY STATE SWITCH BOOLEAN***", this.state.isSwitchOn)
//     const { speakersList, likeCount, hideMoreSpeakerBtn, hideMorePkBtn, pkDetailFrom, pkDetailLimit, presentersTotalLimit, presentersCurrentLimit, pkDetailData, pkMoreDataLoader,page_title, pkRecentDetailData, pkRecentDetailFrom, pkRecentDetailLimit, pkRecentMoreDataLoader, hideMorePkRecentBtn } = this.state;
//     const { loading, cityDetailInfo, organizerArr, locationOwner, noOrganizer, spotlightPk, spotlightPkPresenter, all_eventArr } = this.state;
//     //const { city_name, description, facebook_handle, twitter_handle, instagram_handle, youtube_handle, city_skyline_wide_image_url, image_urls, city_skyline_image_url } = cityDetailInfo;
//     const { city_name, description, facebook_handle, twitter_handle, instagram_handle, youtube_handle } = cityDetailInfo;
//     //const imagesList = city_skyline_wide_image_url && image_urls ? image_urls.concat(city_skyline_wide_image_url).reverse() : city_skyline_image_url;
//     const imagesList = cityDetailInfo.rotating_images;

//     let { match: { params: { friendly_url } = {} } = {} } = this.props
//     friendly_url = friendly_url.toLowerCase();

//     if (loading) {
//       return (
//           <React.Fragment>
//             <Helmet defer={false}>
//               <title>{page_title}</title>
//               <meta name="description" content={`PechaKucha ${city_name}: Events and Presentations. All in 20x20 Pecha Kucha format.`} />
//               <meta property="og:type" content="website" />
//               <meta property="og:url" content={`https://www.pechakucha.com${local_routes.cities}/${friendly_url}`} />
//               <meta property="og:title" content={page_title} />
//               <meta property="og:description" content={`PechaKucha ${city_name}: Events and Presentations. All in 20x20 Pecha Kucha format.`} />
//             </Helmet>
//             <ActivityIndicator theme="spinner" />
//           </React.Fragment>
//       )
//     }
//     else {
//       return (
//         <div className="main-section new-city-section">
//           <React.Fragment>
//             <Helmet defer={false}>
//               <title>{page_title}</title>
//               <meta name="description" content={`PechaKucha ${city_name}: Events and Presentations. All in 20x20 Pecha Kucha format.`} />
//               <meta property="og:type" content="website" />
//               <meta property="og:url" content={`https://www.pechakucha.com${local_routes.cities}/${friendly_url}`} />
//               <meta property="og:title" content={page_title} />
//               <meta property="og:description" content={`PechaKucha ${city_name}: Events and Presentations. All in 20x20 Pecha Kucha format.`} />
//             </Helmet>

//             {/* Banner section starts */}
//             <CityBanner
//               followed={this.state.followed}
//               city_info={this.state.cityDetailInfo}
//               carouselImage={imagesList || []}
//               CityImage={CityImage}
//               logoCity={logoCity}
//               cityName={city_name}
//               cityDes={description}
//               locationOwner={locationOwner}
//               facebookHandle={facebook_handle}
//               twitterHandle={twitter_handle}
//               instagramHandle={instagram_handle}
//               youtubeHandle={youtube_handle}
//               noOrganizer={noOrganizer}
//               friendly_url={cityDetailInfo.friendly_url}
//               openCityHeading={'This City is Open - Apply Now!'}
//               openCityDes={'If you think you have what it takes to run PechaKucha Nights in your city, apply to become the official organizer!'} />
//             {/* Banner section Ends */}

//             {/* Upcoming Events Section Starts Here */}
//               <div className="marBot20">
//                 <Container>
//                   <h1 className="city-heading">PechaKucha {city_name}</h1>
//                   <TitleSection
//                     title="Upcoming & Recent Events"
//                     seeAll="false"
//                     //seeAll={cityArr.length > 0 ? "false" : "false"}
//                     Title_link="#"
//                   />
//                  {all_eventArr.length > 0 ?
//                  <React.Fragment>
//                   {this.eventsList(all_eventArr)}
//                   {!this.state.gotAllAll &&
//                     <div>
//                       {this.state.loadMoreLoader === true ?
//                         <ActivityIndicator theme="spinnerNoMargin" />
//                         :
//                         <p style={{ textAlign: 'center', marginTop: '20px', marginBottom: 40, color: '#fff' }}><span onClick={() => this.showMoreEvents('all', city_name, this.state.from, this.state.limit)} className="loadmore-btn">Show More Events</span></p>
//                       }
//                     </div>
//                   }
//                   </React.Fragment>
//                   :
//                   <EmptyUpcomingEvents emptyEventImg={emptyEventImg} noEventHeading={"There haven't been any events in this city yet."}
//               addCityHeading={'Would you like to see a PechaKucha Night event in your city?'}
//               applyCityDescription={"If you think you have what it takes to run PechaKucha Night in your city, apply to become the official organizer! Join the celebration of cretivity by becoming part of our global network of volunteers and put your city's creative talent and hidden heroeson the world stage!"} />
//                 }
//                 </Container>
//               </div>
             
//             {/* Upcoming Events Section Ends Here */}

//             {/* Presentation Section Starts Here */}
//             {
//               spotlightPk && spotlightPk.presentation_video_url &&
//               <SpotLightPk
//                 city_or_channel_name={city_name}
//                 //presentation_data={spotlightPk.presentation_video_url}
//                 entity_name={spotlightPk.entity_name}
//                 description={spotlightPk.description}
//                 avatar_image_url={spotlightPkPresenter && spotlightPkPresenter.avatar_image_url && spotlightPkPresenter.avatar_image_url}
//                 firstName={spotlightPkPresenter.firstname}
//                 lastName={spotlightPkPresenter.lastname}
//                 designation={spotlightPkPresenter.description}
//                 full_name={(spotlightPkPresenter.firstname && spotlightPkPresenter.lastname) ? `${spotlightPkPresenter.firstname} ${spotlightPkPresenter.lastname}` : (spotlightPkPresenter.firstname) ? `${spotlightPkPresenter.firstname}` : ''}
//                 presenter_friendly_url={spotlightPk.friendly_url}
//                 friendly_url={spotlightPk.friendly_url}
//                 mailTo="mailto:support@pechakucha.org"
//                 textReport="Report"
//                 iconName="fa fa-flag"
//                 iconNameLike="fa fa-heart"
//                 noOfLikes={likeCount}
//                 handleClick={this.handleClickLike}
//                 likeLabel={this.state.labelLike}
//                 presentation_data={spotlightPk}
//                 likeLoader={this.state.likeLoader}
//               />
//             }

//             {/* Presentation Section Ends Here */}
// 						<Container className="mt-3">
// 							<Row className="justify-content-between wrap">
// 								<Col md={7}>
// 									{(this.state.isSwitchOn===false)?(
// 										<h2 className="mt-2">{`Trending PechaKucha ${city_name} Presentations`}</h2>
// 									):(
// 										<h2 className="mt-2">{`Recent PechaKucha ${city_name} Presentations`}</h2>
// 									)}
// 								</Col>
// 								<Col xs={6} md={4}>
// 									{pkDetailData.length>0?(<Form className="mt-3 ml-5" >
// 									<Form.Switch
// 									  className="ml-2"
// 									  style={{transform: "scale(1.5)", color: 'black'}}
// 										onChange={this.onSwitchAction}
// 										id="custom-switch"
// 										label=<span><span style={{ fontWeight: !this.state.isSwitchOn ? 'bold' : 'lighter'}}>Trending</span> <span style={{ fontWeight: 'lighter', fontStyle: 'italic' }}>or</span> <span style={{ fontWeight: this.state.isSwitchOn ? 'bold' : 'lighter'}}>Recent</span></span>
// 										checked={this.state.isSwitchOn}
// 									/>
// 									</Form>):(null)}
// 								</Col>
// 							</Row>
// 						</Container>
//             {/* Trending Presentation Section Starts Here */}
// 						{(this.state.isSwitchOn===false)?(
// 								pkDetailData.length > 0 &&
// 								<div className="container">
// 									<div className="city-presentation-section presentation-section">
// 										<div>
// 											<Row>
// 												{
// 													pkDetailData.map((item, index) => {
// 														let itemField = item.entity_info;
// 														return (
// 															<Col lg={4} sm={12} md={6} key={index}>
// 															 <PresentationCard
// 																		key={itemField.entity_uuid}
// 																		presentation_info={itemField}
// 																/>                            
// 																{/*
// 																<Trending key={index}
// 																	Trending_now_title={itemField.entity_name}
// 																	Trending_now_text={itemField.description}
// 																	Trending_img={itemField.image_url}
// 																	Trending_link={`${local_routes.presentations}/${itemField.friendly_url}`}
// 																/>
// 																*/}
// 															</Col>
// 														)
// 													}
	
// 													)}
// 											</Row>
// 											{
// 												pkMoreDataLoader === false ?
// 													<React.Fragment>
// 														{
// 															hideMorePkBtn === false &&
// 															<div className="show-more-btn">
// 																<Button OnClickMet={() => this.getMorePkDetailData(city_name, pkDetailFrom, pkDetailLimit)} theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket" style={{ width: 'auto' }}>
// 																	Show More Presentations
// 															 </Button>
// 															</div>
// 														}
// 													</React.Fragment>
// 													:
// 													<div className="show-more-btn">
// 														<ActivityIndicator theme="spinner show-more-spinner" />
// 													</div>
// 											}
// 										</div>
// 									</div>
// 								</div>
							
// 							// /* Trending Presentation Section Ends Here */
// 						):(
// 							//** RECENT presentations section starts here*/
// 							pkRecentDetailData.length > 0 &&
// 								<div className="container">
// 									<div className="city-presentation-section presentation-section">
// 										<div>
// 											<Row>
// 												{
// 													pkRecentDetailData.map((item, index) => {
// 														let itemField = item.entity_info;
// 														return (
// 															<Col lg={4} sm={12} md={6} key={index}>
// 															 <PresentationCard
// 																		key={itemField.entity_uuid}
// 																		presentation_info={itemField}
// 																/>                            
// 																{/*
// 																<Trending key={index}
// 																	Trending_now_title={itemField.entity_name}
// 																	Trending_now_text={itemField.description}
// 																	Trending_img={itemField.image_url}
// 																	Trending_link={`${local_routes.presentations}/${itemField.friendly_url}`}
// 																/>
// 																*/}
// 															</Col>
// 														)
// 													}
	
// 													)}
// 											</Row>
// 											{
// 												pkRecentMoreDataLoader === false ?
// 													<React.Fragment>
// 														{
// 															hideMorePkRecentBtn === false &&
// 															<div className="show-more-btn">
// 																<Button OnClickMet={() => this.getMorePkRecentDetailData(city_name, pkRecentDetailFrom, pkRecentDetailLimit)} theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket" style={{ width: 'auto' }}>
// 																	Show More Presentations
// 															 </Button>
// 															</div>
// 														}
// 													</React.Fragment>
// 													:
// 													<div className="show-more-btn">
// 														<ActivityIndicator theme="spinner show-more-spinner" />
// 													</div>
// 											}
// 										</div>
// 									</div>
// 								</div>
// 								//**End RECENT SECTION HERE */
// 						)}
            
//             {/* Event Speakers Section Starts Here */}
//             {
//               speakersList.length > 0 &&
//               <div className="container">
//                 <div className=" presentation-section speakers-section">
//                   <TitleSection title={`${city_name} Speakers`} />
//                   <div>
//                     <Row>
//                       {
//                         speakersList.slice(0, presentersCurrentLimit).map((item, index) =>
//                           <Col key={index} sm={12} md={6} lg={6}>
//                             <Organizer
//                               show_Icon={false}
//                               Organizer_firstname={item.firstname}
//                               Organizer_lastname={item.lastname}
//                               Organizer_text={item.description}
//                               profile_pic={item.avatar_image_url}
//                               Organizer_link={
//                                 (item.friendly_url !== undefined && item.friendly_url !== null && item.status_code === 1) ? `${local_routes.users}/${item.friendly_url}`
//                                 : null
//                               }
//                             />
//                           </Col>
//                         )}
//                     </Row>
//                     {
//                       presentersTotalLimit > 6 && hideMoreSpeakerBtn === false &&
//                       <div className="show-more-btn">
//                         <Button OnClickMet={() => this.showAllPresenters()} theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket" style={{ width: 'auto' }}>
//                           Show More Speakers
//                     </Button>
//                       </div>
//                     }
//                   </div>
//                 </div>
//               </div>
//             }

//             {/* Event Speakers Section Ends Here */}

//             {/* Skipping for now */}
//             {/* Speack About PechaKucha Night Section Starts Here */}
//             {/* <AddCityPresenters speakPresentersHeading={'Speak At PechaKucha Night Tokyo!'}
//               addCityDescription={'Intereted at speaking at one of our upcoming events, apply by filling-out our contact form.'}
//               btnText="Apply Now" /> */}
//             {/* Speack About PechaKucha Night Section Ends Here */}

//             {/* Organizers Section Starts Here */}
//             {
//               organizerArr.length > 0 &&
//               <div className="container">
//                 <div className="city-organizers-section speakers-section">
//                   <TitleSection title= {`${city_name} Organizers`} />
//                   <div>
//                     <Row>
//                       {
//                         organizerArr.map((item) =>
//                           <Col key={item.entity_uuid} sm={6}>
//                             <Organizer
//                               show_Icon={true}
//                               Organizer_firstname={item.Organizer_firstname}
//                               Organizer_lastname={item.Organizer_lastname}
//                               profile_pic={item.avatar_image_url}
//                               Organizer_text={item.Organizer_text}
//                               twitter_handle={item.twitter_handle}
//                               facebook_handle={item.facebook_handle}
//                               website_url={item.website_url}
//                               youtube_handle={item.youtube_handle}
//                               Organizer_link={(item.friendly_url !== undefined && !null) && (item.status_code === 1) &&
//                                 `${local_routes.users}/${item.friendly_url}`}
//                             />
//                           </Col>
//                         )}
//                     </Row>
//                   </div>
//                 </div>
//               </div>

//             }

//             {/* Organizer ends */}

//             {/* Skipping for now */}
//             {/* Support PechaKucha Night Section Starts Here */}
//             {/* <AddCityPresenters speakPresentersHeading={'Help Support PechaKucha Night Tokyo!'}
//               addCityDescription={"we always welcome a helping hand as we organize PechaKucha Night Events. Fill-out our contact form let us know how you'd like to help."}
//               btnText="Contact Us" /> */}
//             {/* Support PechaKucha Night Section Ends Here */}

//             <Footer
//               homeImg={home}
//               homeImgRef="/"
//               breadcrumbSubPage="City"
//             />
//           </React.Fragment>

//         </div>
//       )
//     }
//   }
// }

// export default City;
